import React, { useState } from 'react';
import './Login.css';
import logo from './assets/Upload.svg';

function VerifyEmail({ email, onVerify, onBackToLogin }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (code.trim().length !== 6) {
      setError('Ingresa el código de 6 dígitos');
      return;
    }

    setLoading(true);

    try {
      await onVerify({
        email,
        code: code.trim()
      });
    } catch (verifyError) {
      setError(verifyError.message || 'No fue posible verificar el correo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src={logo} alt="Pile" className="login-logo" />

        <p>Ingresa el código enviado a {email}</p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            inputMode="numeric"
            maxLength="6"
            placeholder="Código de 6 dígitos"
            value={code}
            onChange={(event) => {
              const value = event.target.value.replace(/\D/g, '');
              setCode(value);
            }}
            required
          />

          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="login-primary-button"
            disabled={loading}
          >
            {loading ? 'Verificando...' : 'Verificar correo'}
          </button>

          <button
            type="button"
            className="login-secondary-button"
            onClick={onBackToLogin}
          >
            Volver a iniciar sesión
          </button>
        </form>
      </div>
    </div>
  );
}

export default VerifyEmail;
